import axios from "axios";
import { clearSession } from "../auth/session";

// 모든 요청은 이 인스턴스를 거친다. base 는 nginx 뒤 같은 오리진(/api/v2)이
// 기본이고, 개발에서는 vite 프록시가 8200 으로 넘긴다.
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE ?? "/api/v2",
});

// 토큰을 붙이지 않는다. 서버가 httpOnly 쿠키로 주고 브라우저가 같은 오리진 요청에
// 자동으로 싣는다. 스크립트가 토큰을 만질 일이 없다.

// 401 이면 토큰을 버리고 로그인으로. 라우터 밖이라 location 으로 이동한다.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      clearSession();
      if (location.pathname !== "/login") location.assign("/login");
    }
    return Promise.reject(error);
  }
);

// 오류 봉투 읽기는 순수 모듈에 두고 여기서 내놓는다 — 시험이 client 를 가짜로 바꿔도 같이 쓰인다.
export { apiErrorMessage, apiErrorCode } from "./errors";
